import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
import { motion } from 'framer-motion';
export function CostSection() {
  const costs = [{
    situation: '3 hs de planificación × 40 semanas',
    cost: '120 horas por año'
  }, {
    situation: 'Sin banco de frases clínicas',
    cost: '1 hora extra de registro por día'
  }, {
    situation: 'Sin sistema de primera consulta',
    cost: 'Pacientes que no vuelven'
  }, {
    situation: 'Sin menús rotativos',
    cost: "Domingos respondiendo '¿qué como?'"
  }, {
    situation: 'Sin gestión de WhatsApp',
    cost: 'Mensajes sin responder, turnos perdidos'
  }, {
    situation: 'Sin tarifario actualizado',
    cost: 'Ingresos reales que bajan con la inflación'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-95">
      <FadeIn data-id="element-96">
        <div className="text-center mb-6 md:mb-14" data-id="element-97">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-red-500/10 mb-3 md:mb-6 border border-red-500/20" data-id="element-98">
            <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(239,68,68,0.4)]" data-id="element-99">
              ⚖️
            </span>
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-4 px-2" data-id="element-100">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <p className="text-sm md:text-xl text-gray-400 font-medium" data-id="element-101">
            El precio de seguir haciendo todo manual.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-102">
        {costs.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-103">
            <motion.div whileHover={{
          scale: 1.02
        }} className="bg-gradient-to-r from-gray-900 to-black border border-gray-800 hover:border-red-900/50 rounded-2xl p-4 md:p-6 flex flex-col justify-between h-full group relative overflow-hidden" data-id="element-104">
              <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-red-500/10 transition-colors" data-id="element-105"></div>

              <p className="text-sm md:text-base text-gray-400 font-medium mb-3 md:mb-4 relative z-10" data-id="element-106">
                {item.situation}
              </p>

              <div className="flex items-center gap-2 md:gap-3 bg-red-950/30 p-3 md:p-4 rounded-xl border border-red-900/30 relative z-10" data-id="element-107">
                <AlertOctagon className="text-red-500 shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-108" />
                <span className="font-bold text-red-400 text-sm md:text-lg leading-tight" data-id="element-109">
                  {item.cost}
                </span>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}